module.exports = __webpack_public_path__ + "static/media/9.6d7d9a79.jpg";